declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenBool, AutoGenList } from '../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-listpv',
    templateUrl: './autogenlistpv.component.html',
    styleUrls: ['./autogenlistpv.component.scss']
})

export class AutoGenListPVComponent implements OnInit {
    @Input() public mode;
    @Input() public Data: AutoGenList;
    @Input() public field: FieldData;
    ngOnInit(): void {
        //alert('from list'+this.mode);
    }
}
